<div class="container-fluid">
  <div class="row">
    <div class="col">
      <strong>{{'envelope.signatory.name' | translate }}</strong>
      <fa-icon ngbTooltip="{{'envelope.signatory.tooltip.signatory' | translate}}" container="body" class="ml-1"
        data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
    </div>
  </div>

  <div class="form-horizontal">
    <div class="row align-items-center pb-2">
      <div class="d-none d-sm-block col-sm-2">
        <small class="text-muted">{{'quantity' | translate | titlecase }}: {{model.elements?.length}}
        </small>
      </div>
      <div
        class="col-sm-10 d-flex flex-md-row-reverse align-items-center justify-content-end justify-content-md-start justify-content-sm-end toolbar">

        <cdx-toolbar-search *ngIf="((model.elements?.length > 0) || (searchText))" class="button-right"
          (onTyping)="onSearch($event)" [value]="searchText" [placeholder]="'search' | translate | titlecase"
          [maxlength]="255" [debounceTime]="600">
        </cdx-toolbar-search>

        <div class="d-flex">
          <cdx-custom-dropdown 
            #signatoryTypeRoleDropdown
            [options]="signatoryTypeRoleItems"
            [isLoadingItems]="isLoadingSignatoryTypeRoles"
            [hidden]="!anyCheckedElement()"
            ngbTooltip="{{'envelope.signatory.tooltip.signatureActions' | translate}}"
            (onSearchTyping)="onSignatoryTypeRoleSearch($event)"
            (onDropdownCustomInfiniteScroll)="onSignatoryTypeRoleInfiniteScroll($event)"
            (onSelectItem)="onSubscriberTypeChange($event)"
            (click)="onSignatoryTypeRoleDropdownClick()">
          </cdx-custom-dropdown>

          <button ngbDropdown class="cdx-button cdx-button--icon cdx-button--lg mr-1" [hidden]="!anyCheckedElement()"
            ngbTooltip="{{'envelope.signatory.tooltip.signatureType' | translate}}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','pen-alt']" ngbDropdownToggle aria-haspopup="true"
              aria-expanded="false">
            </fa-icon>
            <div ngbDropdownMenu>
              <div ngbDropdownItem cdx-click-stop-propagation>
                <b>{{'envelope.signatory.signatureTypeText' | translate}}</b>
              </div>
              <button ngbDropdownItem *ngFor="let item of signatureTypeItems" class="text-truncate"
                (click)="emitSignType(item)">
                <span>{{item.value}}</span>
              </button>
            </div>
          </button>

          <button class="cdx-button cdx-button--icon cdx-button--lg mr-1"
            (click)="showOrdersSignatoryModal(modalOrderSignatory)" [hidden]="model.elements?.length <= 1"
            ngbTooltip="{{'envelope.signatory.tooltip.orderAdjust' | translate}}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','list-ol']"></fa-icon>
          </button>

          <button class="cdx-button cdx-button--icon cdx-button--lg mr-1" [hidden]="!anyCheckedElement()"
            (click)="showConfirmationDelete(confirmDeleteModal)"
            ngbTooltip="{{'envelope.signatory.tooltip.removeSignatory' | translate}}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','minus-circle']"></fa-icon>
          </button>

          <button class="cdx-button cdx-button--icon cdx-button--lg mr-1 border-less"
            (click)="showAddSignatoryModal(modalAddSignatory)"
            ngbTooltip="{{'envelope.signatory.tooltip.addSignatory' | translate}}">
            <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','plus-circle']"></fa-icon>
          </button>

        </div>

        <div class="d-none d-lg-block">
          <span class="d-flex ml-auto">
            <cdx-toggle-switch class="mr-2" [toggledOn]="model.accessAuthentication" (toggle)="onToggleAccessAuthentication($event)">
            </cdx-toggle-switch>
            {{'envelope.signatory.accessAuthentication' | translate}}
            <fa-icon ngbTooltip="{{'envelope.signatory.tooltip.accessAuthentication' | translate}}" placement="left"
              class="ml-1 mr-1" size="sm" [icon]="['fas','question-circle']">
            </fa-icon>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="pl-2 pr-2">
    <ng-container *ngIf="model.elements.length > 0; else blankSlateTable">
      <cdx-data-table [options]="dataTableOptions" (onDataTableChange)="onDataTableChange($event)"></cdx-data-table>
    </ng-container>
  </div> -->

  <div class="row">
    <div class="col">
      <div
        #signatoryTableContainer
        class="table-responsive table-box table-hover"
        *ngIf="model.elements.length > 0; else blankSlateTable">
        <ng-container>
          <table class="table">
            <thead>
              <tr>
                <th
                  scope="col"
                  width="40"
                  class="text-center selection-column"
                  (click)="onCheckboxAll(!checkboxAllElements)"
                  tabindex="0"
                  (keyup.enter)="onCheckboxAll(!checkboxAllElements)"
                >
                  <div class="d-flex justify-content-left">
                    <fa-icon
                      class="fa-lg"
                      [icon]="['fal', 'square']"
                      *ngIf="!anyCheckedElement()"
                    ></fa-icon>
                    <fa-icon
                      class="fa-lg"
                      [icon]="['fas', 'minus-square']"
                      *ngIf="anyCheckedElement() && !checkboxAllElements"
                    ></fa-icon>
                    <fa-icon
                      class="fa-lg"
                      [icon]="['fas', 'check-square']"
                      *ngIf="checkboxAllElements"
                    ></fa-icon>
                  </div>
                </th>
                <th scope="col" class="w-60-table text-left" *ngIf="model.isOrdered">
                  {{'order' | translate | titlecase}}</th>
                <th scope="col" class="text-left">
                  {{'name' | translate | titlecase}}</th>
                <th scope="col" class="text-left">
                  {{'mail' | translate | titlecase}}</th>
                <th *ngIf="settings.language.id === 1" scope="col" class="text-left">
                  {{'ssn' | translate | uppercase}}</th>
                <th *ngIf="!hiddenPhoneColumn" scope="col" class="text-left">
                  {{ 'phone' | translate }} </th>
                <th scope="col" class="text-left signatureTypeTextMobile">
                  {{'envelope.signatory.signatureTypeText' | translate }}</th>
                <th scope="col" class="text-left">
                    {{'envelope.signatory.subscriberTypeText' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of model.elements; index as i; trackBy: trackById" [ngClass]="{ 'row-active': element.checked }">
                <td width="35">
                  <div class="d-flex justify-content-left">
                  <span
                    class="cursor-pointer"
                    (click)="onCheckbox(!element.checked, element)"
                    tabindex="0"
                    (keyup.enter)="onCheckbox(!element.checked, element)"
                  >
                    <fa-icon
                      class="fa-lg"
                      [icon]="[(element.checked ? 'fas' : 'fal'), (element.checked ? 'check-square' : 'square')]"
                    ></fa-icon>
                  </span>
                </div>
                </td>
                <td class="text-truncate text-left" *ngIf="model.isOrdered">
                  {{element.order}}</td>
                <td class=" text-truncate text-left">
                  {{element.name}}</td>
                <td class=" text-truncate text-left">
                  {{element.mail | mailObfuscate }}</td>
                <td *ngIf="settings.language.id === 1" class=" text-truncate text-left">
                  {{element.ssnWithMask}}</td>
                <td *ngIf="!hiddenPhoneColumn" class="text-truncate text-left">
                  {{element.phoneNumber | phoneObfuscate}}</td>
                <td class="text-left dropdown-cell">
                  <div
                    class="signatory-table-dropdown"
                    [style.max-width.px]="signatoryTableDropdownWidth">
                    <cdx-dropdown
                      [options]="signatureTypeDropdownOptions"
                      [selectedItem]="getSelectedSignatureType(element)"
                      [maxWidthButton]="signatoryTableDropdownWidth"
                      [maxWidthOptions]="signatoryTableDropdownWidth"
                      [placement]="['bottom-left','top-left']"
                      (onSelectItem)="onSignatureTypeChange(element, $event)">
                    </cdx-dropdown>
                  </div>
                </td>
                <td class="text-left dropdown-cell subscriber-type-cell">
                  <div
                    class="signatory-table-dropdown"
                    [style.max-width.px]="signatoryTableDropdownWidth">
                    <cdx-dropdown
                      [options]="signatoryTypeRoleDropdownOptions"
                      [selectedItem]="getSelectedSignatoryTypeRole(element)"
                      [maxWidthButton]="signatoryTableDropdownWidth"
                      [maxWidthOptions]="signatoryTableDropdownWidth"
                      [placement]="['bottom-left','top-left']"
                      (onSelectItem)="onSignatoryTypeRoleChange(element, $event)">
                    </cdx-dropdown>
                  </div>
                  <cdx-tag
                    class="ml-2"
                    [options]="inactiveTag"
                    *ngIf="element.signatoryTypeRole && !element.signatoryTypeRole?.isActive">
                  </cdx-tag>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="row align-items-center mt-3">
    <div class="col-12 mb-2">
      <strong>{{'envelope.settings.sendReminder' | translate}}</strong>
      <fa-icon ngbTooltip="{{'envelope.signatory.tooltip.frequency' | translate}}" class="ml-2" size="sm"
        [icon]="['fas','question-circle']"></fa-icon>
    </div>
    <div class="col-md-4">
      <cdx-dropdown [options]="rememberOptions" [selectedItem]="model.reminderFrequency"
        (onSelectItem)="onSelectFrequency($event)"></cdx-dropdown>
    </div>
  </div>

  <div class="row align-items-center mt-3">
    <div class="d-none d-lg-block">
      <div class="col mb-2">
        <strong>{{'envelope.authorizer.authorizations' | translate }}</strong>
        <fa-icon ngbTooltip="{{'envelope.authorizer.tooltip.authorizer' | translate}}" class="ml-2"
          data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </div>
      <div class="col">
        <span class="d-flex ml-auto align-items-center">
          <cdx-toggle-switch class="mr-2" [toggledOn]="model.authorizer" (toggle)="onToggleEnableAuthorizer($event)">
          </cdx-toggle-switch>
          {{'envelope.authorizer.enableAuthorizer' | translate }}
        </span>
      </div>
    </div>
  </div>

  <ng-template #blankSlateSearchTemplate>
    <ng-container>
      <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateSearchClick($event)">
        {{'envelope.signatory.blankSlateSearchText' | translate}}</cdx-blankslate>
    </ng-container>
  </ng-template>

  <ng-template #blankSlateTable>
    <div class="p-2 table__container">
      <ng-container *ngIf="(searchText === ''); else blankSlateSearchTemplate">
        <cdx-blankslate [options]="blankSlate" (buttonClick)="showAddSignatoryModal(modalAddSignatory)">
          <span [innerHTML]="'envelope.signatory.blankSlateText' | translate"></span>
        </cdx-blankslate>
      </ng-container>
    </div>
  </ng-template>

  <div class="row d-lg-none">
    <div class="col-12">
      <span class="d-flex ml-auto align-items-center">
        <cdx-toggle-switch class="mr-2" [toggledOn]="model.accessAuthentication" (toggle)="onToggleAccessAuthentication($event)">
        </cdx-toggle-switch>
        {{'envelope.signatory.accessAuthentication' | translate}}
        <fa-icon ngbTooltip="{{'envelope.signatory.tooltip.accessAuthentication' | translate}}" placement="right"
          class="ml-1 mr-1" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </span>
    </div>
    <div class="mt-3">
      <div class="col-12 mb-2">
        <strong>{{'envelope.authorizer.authorizations' | translate }}</strong>
        <fa-icon ngbTooltip="{{'envelope.authorizer.tooltip.authorizer' | translate}}" class="ml-2"
          data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </div>
      <div class="col">
        <span class="d-flex ml-auto align-items-center">
          <cdx-toggle-switch class="mr-2" [toggledOn]="model.authorizer" (toggle)="onToggleEnableAuthorizer($event)">
          </cdx-toggle-switch>
          {{'envelope.authorizer.enableAuthorizer' | translate }}
        </span>
      </div>
    </div>
  </div>
  <div [hidden]="!model.authorizer">
    <envelope-authorizer></envelope-authorizer>
  </div>

  <div class="row align-items-center mt-3">
    <div class="d-none d-lg-block">
      <div class="col mb-2">
        <strong>{{'envelope.observer.observers' | translate }}</strong>
        <fa-icon ngbTooltip="{{'envelope.observer.tooltip.observer' | translate}}" class="ml-2"
          data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </div>
      <div class="col">
        <span class="d-flex ml-auto align-items-center">
          <cdx-toggle-switch class="mr-2" [toggledOn]="model.observer" (toggle)="onToggleEnableObserver($event)">
          </cdx-toggle-switch>
          {{'envelope.observer.enableObserver' | translate }}
        </span>
      </div>
    </div>
  </div>

  <ng-template #blankSlateSearchTemplate>
    <ng-container>
      <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateSearchClick($event)">
        {{'envelope.signatory.blankSlateSearchText' | translate}}</cdx-blankslate>
    </ng-container>
  </ng-template>

  <ng-template #blankSlateTable>
    <ng-container *ngIf="(searchText === ''); else blankSlateSearchTemplate">
      <cdx-blankslate [options]="blankSlate" (buttonClick)="showAddSignatoryModal(modalAddSignatory)">
        <span [innerHTML]="'envelope.signatory.blankSlateText' | translate"></span>
      </cdx-blankslate>
    </ng-container>
  </ng-template>

  <div class="row d-lg-none">
    <div class="mt-3">
      <div class="col-12 mb-2">
        <strong>{{'envelope.observer.observers' | translate }}</strong>
        <fa-icon ngbTooltip="{{'envelope.observer.tooltip.observer' | translate}}" class="ml-2"
          data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </div>
      <div class="col">
        <span class="d-flex ml-auto align-items-center">
          <cdx-toggle-switch class="mr-2" [toggledOn]="model.observer" (toggle)="onToggleEnableObserver($event)">
          </cdx-toggle-switch>
          {{'envelope.observer.enableObserver' | translate }}
        </span>
      </div>
    </div>
  </div>
  <div [hidden]="!model.observer">
    <app-envelope-observer [observersIsToggled]="model.observer"></app-envelope-observer>
  </div>

  <div class="row align-items-center mt-3">
    <div class="d-none d-lg-block">
      <div class="col mb-2">
        <strong>{{'envelope.responsible.form' | translate }}</strong>
        <fa-icon ngbTooltip="{{'envelope.responsible.tooltip.responsible' | translate}}" class="ml-2"
          data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </div>
      <div class="col">
        <span class="d-flex ml-auto align-items-center">
          <cdx-toggle-switch class="mr-2" [toggledOn]="model.responsible" (toggle)="onToggleEnableResponsible($event)" [disabled]="isMobile">
          </cdx-toggle-switch>
          {{'envelope.responsible.enableResponsible' | translate }}
        </span>
        <small *ngIf="isMobile">{{'envelope.responsible.textHelper' | translate }}</small>
      </div>
    </div>
  </div>

  <div class="row d-lg-none">
    <div class="mt-3">
      <div class="col-12 mb-2">
        <strong>{{'envelope.responsible.form' | translate }}</strong>
        <fa-icon ngbTooltip="{{'envelope.responsible.tooltip.responsible' | translate}}" class="ml-2"
          data-placement="bottom" size="sm" [icon]="['fas','question-circle']"></fa-icon>
      </div>
      <div class="col">
        <span class="d-flex ml-auto align-items-center mb-2">
          <cdx-toggle-switch class="mr-2" [toggledOn]="model.responsible" (toggle)="onToggleEnableResponsible($event)" [disabled]="isMobile">
          </cdx-toggle-switch>
          {{'envelope.responsible.enableResponsible' | translate }}
        </span>
        <small *ngIf="isMobile">{{'envelope.responsible.textHelper' | translate }}</small>
      </div>
    </div>
  </div>

  <ng-container *ngIf="model.responsible">
    <app-envelope-responsible></app-envelope-responsible>
  </ng-container>
</div>

<ng-template #modalOrderSignatory>
  <app-signatory-order (closeModalClick)="closeModalClick()" (submitModalClick)="submitModalClick()">
  </app-signatory-order>
</ng-template>

<ng-template #modalAddSignatory>
  <app-participant-modal
    (closeModalClick)="closeModalClick()"
    (submitModalClick)="submitAddModalClick($event)"
    [participantTypeInput]="participantType.Signatory"
    [enableEditContact]="true">
  </app-participant-modal>
</ng-template>

<ng-template #confirmDeleteModal>
  <app-confirm-modal
    [HeaderText]="'envelope.signatory.confirm-disassociate-delete-modal.headerText'"
    [MessageText]="'envelope.signatory.confirm-disassociate-delete-modal.messageText'"
    (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()"
    [ButtonConfirmText]="'disassociateModalActions.remove'"
    [ButtonCancelText]="'disassociateModalActions.cancel'"
    [IsApprovalConfirm]="false"
    [modalIntentType]="modalIntentType.DANGER">
  </app-confirm-modal>
</ng-template>
